export default __webpack_public_path__ + "static/media/fachada-mobile.efc8ad03.png";